import Button from '@/common/components/Button';
import { useCopyButton } from '@/common/hooks/useCopyButton';
import { BankingDepositsData } from '@/features/privateCompanies/types/bankingDeposits/bankingDeposits.type';
import { CopyIcon } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';

interface PixCopyAndPasteProps {
  bankingDeposit: BankingDepositsData;
}

const PixCopyAndPaste = ({ bankingDeposit }: PixCopyAndPasteProps) => {
  const { control, copySuccess } = useCopyButton();

  const Icon = control.icon || CopyIcon;

  return (
    <div className="flex flex-col items-end gap-4">
      <QRCodeSVG
        value={bankingDeposit.payment.source.copy_and_paste || ''}
        size={350}
        level="M"
        marginSize={2}
        imageSettings={{
          src: '/LogoBlack.svg',
          width: 100 * 1.4,
          height: 40 * 1.4,
          excavate: true,
        }}
        data-testid="banking_deposit_qr_code"
      />

      <Button
        onClick={() => copySuccess(bankingDeposit.payment.source.copy_and_paste || '')}
        tooltipMessage={control.message}
        tooltipPlace="bottom"
        dataTestId="banking_deposit_copy_and_paste"
      >
        Pix - Copia e cola

        <Icon strokeWidth={1.5} size={18} />
      </Button>
    </div>
  );
}

export default PixCopyAndPaste;
